import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

/**
 * Simple client-side pagination bar.
 * Renders nothing when total <= pageSize.
 */
export default function Pagination({ page, pageSize, total, onPageChange, testIdPrefix = "pagination" }) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (total <= pageSize) return null;
  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, total);

  return (
    <div className="flex items-center justify-between px-4 py-3 border-t border-slate-100 bg-slate-50 text-sm" data-testid={`${testIdPrefix}-bar`}>
      <div className="text-slate-600">
        Showing <span className="font-semibold text-slate-900">{from}</span>–<span className="font-semibold text-slate-900">{to}</span> of <span className="font-semibold text-slate-900">{total}</span>
      </div>
      <div className="flex items-center gap-2">
        <Button
          size="sm"
          variant="outline"
          disabled={page <= 1}
          onClick={() => onPageChange(page - 1)}
          data-testid={`${testIdPrefix}-prev`}
        >
          <ChevronLeft size={14} className="mr-1" /> Prev
        </Button>
        <span className="text-slate-700 min-w-[80px] text-center" data-testid={`${testIdPrefix}-info`}>
          Page {page} / {totalPages}
        </span>
        <Button
          size="sm"
          variant="outline"
          disabled={page >= totalPages}
          onClick={() => onPageChange(page + 1)}
          data-testid={`${testIdPrefix}-next`}
        >
          Next <ChevronRight size={14} className="ml-1" />
        </Button>
      </div>
    </div>
  );
}
